export default {"src":"/_next/static/media/sunbed_40.c5ce303c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};